import * as Effects from 'redux-saga/effects'
import { dbError, eventsFlushed } from '../../../actions/synchronize/flushData'
import db from '../../../database/indexedDb'

export default function*() {
  try {
    yield db.events.clear()
    yield Effects.put(eventsFlushed())
  } catch (e) {
    yield Effects.put(dbError(e))
  }
}
